export type Line = {
  x: number
  y: number
  size: number
}

export const enum Orientation {
  Horizontal,
  Vertical,
}

export type HorizontalMeasurement = {
  left?: Line
  right?: Line

  leftProjection?: Line
  rightProjection?: Line
}

export type VerticalMeasurement = {
  top?: Line
  bottom?: Line
  topProjection?: Line
  bottomProjection?: Line
}

export type InspectMeasurements = HorizontalMeasurement & VerticalMeasurement

export type MeasurementsData = {
  verticalLine?: Line
  horizontalLine?: Line
  secondHorizontalLine?: Line
  secondVerticalLine?: Line
}
